// Keep in parity with the isolated signing API. Only bounded numeric strokes;
// never caller-provided SVG, HTML, URLs or image data.
export const DRAWN_CONSENT = 'I adopt this drawn signature as my electronic signature for this document and the services shown, and authorize its placement in the customer signature fields.';
export const signatureData = strokes => ({ format: 'drawn-signature-v1', width: 600, height: 180, consentVersion: 'drawn-signature-consent-v1', strokes });
export function validDrawnSignature(s) {
  if (!s || Array.isArray(s) || Object.keys(s).sort().join(',') !== 'consentVersion,format,height,strokes,width'
    || s.format !== 'drawn-signature-v1' || s.consentVersion !== 'drawn-signature-consent-v1'
    || s.width !== 600 || s.height !== 180 || !Array.isArray(s.strokes) || s.strokes.length < 1 || s.strokes.length > 40) return false;
  let count = 0, distance = 0;
  for (const stroke of s.strokes) {
    if (!Array.isArray(stroke) || stroke.length < 2) return false;
    for (let i = 0; i < stroke.length; i++) {
      const p = stroke[i];
      if (++count > 1000 || !Array.isArray(p) || p.length !== 2 || !p.every(Number.isInteger)
        || p[0] < 0 || p[0] > 600 || p[1] < 0 || p[1] > 180) return false;
      if (i) distance += Math.abs(p[0] - stroke[i - 1][0]) + Math.abs(p[1] - stroke[i - 1][1]);
    }
  }
  return distance >= 30;
}
